import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import Navbar from "./components/NavBar";
import Footer from "./components/Footer";

const ProjectDetailsPage = () => {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const docRef = doc(db, "projects", projectId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setProject(docSnap.data());
        } else {
          setError("لا يوجد مشروع بهذا المعرف");
        }
      } catch (err) {
        setError("حدث خطأ أثناء جلب بيانات المشروع");
      } finally {
        setLoading(false);
      }
    };
    fetchProject();
  }, [projectId]);

  if (loading) return <p style={{ textAlign: "center", marginTop: "50px" }}>جارٍ التحميل...</p>;
  if (error) return <p style={{ textAlign: "center", marginTop: "50px", color: "red" }}>{error}</p>;

  return (
    <>
    <Navbar/>
    <div style={{ padding: "80px 20px", maxWidth: "900px", margin: "0 auto", fontFamily: "Cairo, sans-serif" ,textAlign: "right", }}>
      <h1 style={{ color: "#004aad", marginBottom: "20px" }}>{project.title}</h1>
      {project.imageUrl && (
        <img src={project.imageUrl} alt={project.title} style={{ width: "100%", borderRadius: "20px", marginBottom: "25px" }} />
      )}
      {project.date && <p>📅 {project.date}</p>}
      {project.location && <p>📍 {project.location}</p>}
      <p style={{ lineHeight: "1.8", color: "#333", marginTop: "20px" }}>{project.description}</p>
    </div>
    <Footer/>
    </>
  );
};

export default ProjectDetailsPage;
